const serverUrl = process.env.VUE_APP_SERVER_URL
const viewUrl = process.env.VUE_APP_VIEW_URL

// 获取url的query
function getUrlQuery(search) {
  var url = search ? decodeURI(search) : decodeURI(location.search) //获取url中"?"符后的字串
  var theRequest = new Object();
  if (url.indexOf("?") != -1) {
    var str = url.substr(1);
    var strs = str.split("&");
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
    }
  }
  return theRequest;
}

function isUrl(URL) {
  var str = URL
  var Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/
  var objExp = new RegExp(Expression)
  if (objExp.test(str) == true) {
    return true
  } else {
    return false
  }
}

export {
  serverUrl,
  viewUrl,
  getUrlQuery,
  isUrl
}
